import React from 'react';
import styles from './AccountCard.module.scss';
import { Button, ButtonProps } from '../Button/Button';

/** Non-icon-only button props for card action buttons. */
export type AccountCardAction = Omit<
  Extract<ButtonProps, { iconOnly?: false }>,
  'size'
> & {
  label: string;
};

export interface AccountCardProps {
  title: string;
  description?: string;
  amount: string;
  unit: string;
  subvalue?: string | string[];
  actions?: AccountCardAction[];
  className?: string;
  'data-testid': string;
}

export const AccountCard: React.FC<AccountCardProps> = ({
  title,
  description,
  amount,
  unit,
  subvalue,
  actions,
  className,
  'data-testid': dataTestId,
}) => {
  return (
    <div
      className={`${styles['account-card']} ${className || ''}`}
      data-testid={dataTestId}
      aria-label={title}
    >
      <div className={styles['content']}>
        <div className={styles['left']}>
          <h2 className={styles['title']}>{title}</h2>
          {description && (
            <div className={styles['description']}>{description}</div>
          )}
        </div>
        <div className={styles['right']}>
          <div className={styles['amount-row']}>
            <span className={styles['amount']}>{amount}</span>
            <span className={styles['unit']}>{unit}</span>
          </div>
          {subvalue && (
            <div className={styles['subvalue']}>
              {Array.isArray(subvalue)
                ? subvalue.map((line, idx) => <div key={idx}>{line}</div>)
                : subvalue}
            </div>
          )}
        </div>
      </div>
      {actions && actions.length > 0 && (
        <div className={styles['actions']}>
          {actions.map((action, idx) => {
            const { label, ...buttonProps } = action;
            return (
              <Button key={idx} size="sm" {...buttonProps}>
                {label}
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );
};
